module.exports = __webpack_public_path__ + "img/cricket-category-icon-red.355237ad.png";